export const shippingKeys = {
  shipping: ['shipping'],
  createUserShipping: () => [...shippingKeys.shipping, 'createUserShipping'],
  createUserAddress: () => [...shippingKeys.shipping, 'createUserAddress'],
  getUserShipping: (slug: string) => [
    ...shippingKeys.shipping,
    'getUserShipping',
    slug
  ],
  getShippingCarrier: (country?: string) => [
    ...shippingKeys.shipping,
    'getShippingCarrier',
    country
  ],
  updateUserShipping: () => [...shippingKeys.shipping, 'updateUserShipping'],
  getEstimateRate: () => [...shippingKeys.shipping, 'getEstimateRate'],
  getHarmonizedCodes: (keyword: string) => [
    ...shippingKeys.shipping,
    'getHarmonizedCodes',
    keyword
  ],
  getShippingPackages: (params: ShippingPackagesDTO) => [
    ...shippingKeys.shipping,
    'getShippingPackages',
    params
  ]
}
